import { Link } from "react-router-dom";

import { formatDateAt } from "simplydo/core/dates";
import { ideaCoverImage } from "simplydo/core/images";

import { UserChip } from "components/lib/Chips";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";

type FollowedChallengeSubmittedIdeaFeedItemProps = {
  item: FeedItemOfType<"followedChallengeSubmittedIdea">;
};

const FollowedChallengeSubmittedIdeaFeedItem = ({
  item,
}: FollowedChallengeSubmittedIdeaFeedItemProps) => {
  return (
    <FeedItem>
      <FeedItemIcon src={ideaCoverImage(item)} />
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={item.owner} compact="very" />
          </b>{" "}
          <span>
            submitted <Link to={`/ideas/${item._id}`}>{item.name}</Link>
            {item.ownerChallenge?.name ? (
              <>
                {" "}
                to{" "}
                <Link to={`/challenges/${item.ownerChallenge._id}`}>
                  {item.ownerChallenge.name}
                </Link>
              </>
            ) : null}
            .
          </span>
        </FeedItemMessage>
        <FeedItemDate>{formatDateAt(item.submittedAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default FollowedChallengeSubmittedIdeaFeedItem;
